module.exports = __webpack_public_path__ + "static/img/UG.7c3d4ca5.svg";